import React from 'react'
import './Menu.scss';
import sideFoodImg3 from '../../../Assets/Images/side-food-img3.jpg';
import ColeslawGrillSandwich from '../../../Assets/Images/coleslaw-grill-sandwich.jpg';
import VegcheeseGrillSandwich from '../../../Assets/Images/veg-cheese-grill-sandwich.jpg';
import PaneerTikkaGrillSandwich from '../../../Assets/Images/paneer-tikka-grill-sandwich.jpg';
import PaneerChurmaGrillSandwich from '../../../Assets/Images/paneer-churma-grill-sandwich.jpg';
import VegPaneerGrillSandwich from '../../../Assets/Images/veg-paneer-grill-sandwich.jpg';
import ItalianGrillSandwich from '../../../Assets/Images/italian-grill-sandwich.jpg';
import ClassicMargheritaPizza from '../../../Assets/Images/classic-margherita-pizza.jpg';
import SweetCornPizza from '../../../Assets/Images/sweet-corn-pizza.jpg';
import VeggieLovePizza from '../../../Assets/Images/veggie-love-pizza.jpg';
import SpicyGodfatherPizza from '../../../Assets/Images/spicy-godfather-pizza.jpg';
import PaneerTikkaPizza from '../../../Assets/Images/paneer-tikka-pizza.jpg';
import KhedutBhaajiPizza from '../../../Assets/Images/khedut-bhaaji-pizza.jpg';
import CheeseGarlicBread from '../../../Assets/Images/cheese-garlic-bread.jpg';
import ItalianGarlicBread from '../../../Assets/Images/italian-garlic-bread.jpg';
import CheeseChillyToast from '../../../Assets/Images/cheese-chilly-toast.jpg';
import OtloGardenToast from '../../../Assets/Images/otlo-garden-toast.jpg';
import MasalaMaggi from '../../../Assets/Images/masala-maggi.jpg';
import CheeseMaggi from '../../../Assets/Images/cheese-maggi.jpg';
import SchezwanCheeseMaggi from '../../../Assets/Images/schezwan-cheese-maggi.jpg';
import VeggCheeseMaggi from '../../../Assets/Images/vegg-cheese-maggi.jpg';
import AlooTikkiBurger from '../../../Assets/Images/aloo-tikki-burger.jpg';
import AlooTikkiGrillBurger from '../../../Assets/Images/aloo-tikki-grill-burger.jpg';
import SaltedFrenchFries from '../../../Assets/Images/salted-french-fries.jpg';
import PeriPeriFrenchFries from '../../../Assets/Images/peri-peri-french-fries.jpg';
import MaskaBun from '../../../Assets/Images/maska-bun.jpg';
import BreadButter from '../../../Assets/Images/bread-butter.jpg';
import BreadButterJam from '../../../Assets/Images/bread-butter-jam.jpg';
import CheeseBreadButter from '../../../Assets/Images/cheese-bread-butter.jpg';
import SaladSandwich from '../../../Assets/Images/salad-sandwich.jpg';
import NachosWithSauce from '../../../Assets/Images/nachos-with-sauce.jpg';
import NachosWithCheeseAndSauce from '../../../Assets/Images/nachos-with-cheese-and-sauce.jpg';
import OtloTea from '../../../Assets/Images/otlo-tea.jpg';
import LemonCavo from '../../../Assets/Images/lemon-cavo.jpg';
import HerbalTea from '../../../Assets/Images/herbal-tea.jpg';
import IceTea from '../../../Assets/Images/ice-tea.jpg';
import HotCoffee from '../../../Assets/Images/hot-coffee.jpg';
import BlackTea from '../../../Assets/Images/black-tea.jpg';
import BlackCoffee from '../../../Assets/Images/black-coffee.jpg';
import RegularColdCoffee from '../../../Assets/Images/regular-cold-coffee.jpg';
import ColdCoffeeFrappe from '../../../Assets/Images/cold-coffee-frappe.jpg';
import ChocolateColdCoffee from '../../../Assets/Images/chocolate-cold-coffee.jpg';
import CoconutPineappleShake from '../../../Assets/Images/coconut-pineapple-shake.jpg';
import BlueberryShake from '../../../Assets/Images/blueberry-shake.jpg';
import StrawberryShake from '../../../Assets/Images/strawberry-shake.jpg';
import ChocolateShake from '../../../Assets/Images/chocolate-shake.jpg';
import OreoCookiesShake from '../../../Assets/Images/oreo-cookies-shake.jpg';
import KitkatShake from '../../../Assets/Images/kitkat-shake.jpg';
import BrownieShake from '../../../Assets/Images/brownie-shake.jpg';
import NutellaShake from '../../../Assets/Images/nutella-shake.jpg';
import HawaiianerCooler from '../../../Assets/Images/hawaiianer-cooler.jpg';
import MazaMixito from '../../../Assets/Images/maza-mixito.jpg';
import LemonMintMojito from '../../../Assets/Images/lemon-mint-mojito.jpg';
import BlueCuracaoMojito from '../../../Assets/Images/blue-curacao-mojito.jpg';
import GreenAppleMojito from '../../../Assets/Images/green-apple-mojito.jpg';
import StrawberryMojito from '../../../Assets/Images/strawberry-mojito.jpg';
import ChoconillMix from '../../../Assets/Images/choconill-mix.jpg';
import FudgeBrownie from '../../../Assets/Images/fudge-brownie.jpg';
import OtloDevil from '../../../Assets/Images/otlo-devil.jpg';
import LemonShot from '../../../Assets/Images/lemon-shot.jpg';

export default function Menu() {
  return (
    <div>
      <section className='subBanner textCenter'>
          <div className='middle_box'>
            <h1>Menu</h1>
          </div>
      </section>
      <section className='menuWrap'>
        <div className='container'>
            <div className='row'>
                <div className='col-md-2'>
                    <div className='sidebar_wrap'>
                        <ul>
                           <li><a href="#">Sandwich</a></li> 
                           <li><a href="#">Pizza</a></li> 
                           <li><a href="#">Garlic Bread</a></li> 
                           <li><a href="#">Toast</a></li> 
                           <li><a href="#">Maggi</a></li> 
                           <li><a href="#">Burger</a></li> 
                           <li><a href="#">French Fries</a></li> 
                           <li><a href="#">Quick Bite</a></li> 
                           <li><a href="#">Beverages</a></li> 
                           <li><a href="#">Coffee</a></li> 
                           <li><a href="#">Thickshake</a></li> 
                           <li><a href="#">Mocktails</a></li> 
                           <li><a href="#">Dessert</a></li> 
                           <li><a href="#">Combo Offer</a></li> 
                           <li><a href="#">Extra</a></li> 
                        </ul>
                    </div>
                </div>
                <div className='col-md-10'>
                    <div className='hrbg'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='menuTitle'>
                                    <h4>Sandwich</h4>
                                    <span>9 items</span>
                                </div> 
                            </div>
                        </div>     
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={ColeslawGrillSandwich} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Coleslaw Grill Sandwich</h3>
                                            <h3>Rs. 139</h3>                                            
                                        </a>
                                    </div>                                        
                                </div> 
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={VegcheeseGrillSandwich} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Veg Cheese Grill Sandwich</h3>
                                            <h3>Rs. 149</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>  
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={PaneerTikkaGrillSandwich} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Paneer Tikka Grill Sandwich</h3>
                                            <h3>Rs. 149</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>  
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={PaneerChurmaGrillSandwich} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Paneer Churma Grill Sandwich</h3>
                                            <h3>Rs. 159</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={VegPaneerGrillSandwich} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Otlo Magic Grill Sandwich</h3>
                                            <h3>Rs. 179</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={VegPaneerGrillSandwich} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Veg Paneer Grill Sandwich</h3>
                                            <h3>Rs. 199</h3>                                            
                                        </a>
                                    </div>                                        
                                </div> 
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={ItalianGrillSandwich} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Italian Grill Sandwich</h3>
                                            <h3>Rs. 199</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>  
                            </div>
                        </div>  
                    </div>   
                    <div className='hrbg'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='menuTitle'>
                                    <h4>Pizza</h4>
                                    <span>9 items</span>
                                </div> 
                            </div>
                        </div>     
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={ClassicMargheritaPizza} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Classic Margherita Pizza</h3>
                                            <h3>Rs. 149</h3>                                            
                                        </a>
                                    </div>                                        
                                </div> 
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={SweetCornPizza} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Sweet Corn Pizza</h3>
                                            <h3>Rs. 159</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>  
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={VeggieLovePizza} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Veggie Love Pizza</h3>
                                            <h3>Rs. 169</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>  
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={SpicyGodfatherPizza} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Spicy Godfather Pizza</h3>
                                            <h3>Rs. 179</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={PaneerTikkaPizza} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Paneer Tikka Pizza</h3>
                                            <h3>Rs. 189</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={KhedutBhaajiPizza} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Khedut Bhaaji Pizza</h3>
                                            <h3>Rs. 199</h3>                                            
                                        </a>
                                    </div>                                        
                                </div> 
                            </div>
                        </div>  
                    </div>     
                    <div className='hrbg'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='menuTitle'>
                                    <h4>Garlic Bread</h4>
                                    <span>9 items</span>
                                </div> 
                            </div>
                        </div>     
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={CheeseGarlicBread} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Cheese Garlic Bread</h3>
                                            <h3>Rs. 129</h3>                                            
                                        </a>
                                    </div>                                        
                                </div> 
                            </div>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={ItalianGarlicBread} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Italian Garlic Bread</h3>
                                            <h3>Rs. 149</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                        </div>  
                    </div>   
                    <div className='hrbg'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='menuTitle'>
                                    <h4>Toast</h4>
                                    <span>9 items</span>
                                </div> 
                            </div>
                        </div>     
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={CheeseChillyToast} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Cheese Chilly Toast</h3>
                                            <h3>Rs. 99</h3>                                            
                                        </a>
                                    </div>                                        
                                </div> 
                            </div>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={OtloGardenToast} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Otlo Garden Toast</h3>
                                            <h3>Rs. 129</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                        </div>  
                    </div> 
                    <div className='hrbg'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='menuTitle'>
                                    <h4>Maggi</h4>
                                    <span>9 items</span>
                                </div> 
                            </div>
                        </div>     
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={MasalaMaggi} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Masala Maggi</h3>
                                            <h3>Rs. 49</h3>                                            
                                        </a>
                                    </div>                                        
                                </div> 
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={CheeseMaggi} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Cheese Maggi</h3>
                                            <h3>Rs. 69</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={SchezwanCheeseMaggi} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Schezwan Cheese Maggi</h3>
                                            <h3>Rs. 79</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={VeggCheeseMaggi} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Vegg Cheese Maggi</h3>
                                            <h3>Rs. 89</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                        </div>  
                    </div> 
                    <div className='hrbg'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='menuTitle'>
                                    <h4>Burger</h4>
                                    <span>9 items</span>
                                </div> 
                            </div>
                        </div>     
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={AlooTikkiBurger} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Aloo Tikki Burger</h3>
                                            <h3>Rs. 59</h3>                                            
                                        </a>
                                    </div>                                        
                                </div> 
                            </div>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={AlooTikkiGrillBurger} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Aloo Tikki Grill Burger</h3>
                                            <h3>Rs. 79</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                        </div>  
                    </div> 
                    <div className='hrbg'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='menuTitle'>
                                    <h4>French Fries</h4>
                                    <span>9 items</span>
                                </div> 
                            </div>
                        </div>     
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={SaltedFrenchFries} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Salted French Fries</h3>
                                            <h3>Rs. 79</h3>                                            
                                        </a>
                                    </div>                                        
                                </div> 
                            </div>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={PeriPeriFrenchFries} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Peri Peri French Fries</h3>
                                            <h3>Rs. 89</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                        </div>  
                    </div> 
                    <div className='hrbg'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='menuTitle'>
                                    <h4>Tiny Bites</h4>
                                    <span>9 items</span>
                                </div> 
                            </div>
                        </div>     
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={MaskaBun} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Maska Bun</h3>
                                            <h3>Rs. 30</h3>                                            
                                        </a>
                                    </div>                                        
                                </div> 
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={BreadButter} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Bread Butter</h3>
                                            <h3>Rs. 30</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={BreadButterJam} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Bread Butter Jam</h3>
                                            <h3>Rs. 30</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={CheeseBreadButter} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Cheese Bread Butter</h3>
                                            <h3>Rs. 40</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={SaladSandwich} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Salad Sandwich</h3>
                                            <h3>Rs. 50</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={NachosWithSauce} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Nachos With Sauce</h3>
                                            <h3>Rs. 69</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={NachosWithCheeseAndSauce} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Nachos With Cheese And Sauce</h3>
                                            <h3>Rs. 99</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                        </div>  
                    </div>
                    <div className='hrbg'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='menuTitle'>
                                    <h4>Hot Tea Coffee</h4>
                                    <span>9 items</span>
                                </div> 
                            </div>
                        </div>     
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={OtloTea} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Otlo Tea</h3>
                                            <h3>Rs. 30</h3>                                            
                                        </a>
                                    </div>                                        
                                </div> 
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={LemonCavo} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Lemon Cavo</h3>
                                            <h3>Rs. 30</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={HerbalTea} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Herbal Tea</h3>
                                            <h3>Rs. 30</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={IceTea} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Ice Tea</h3>
                                            <h3>Rs. 50</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={HotCoffee} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Hot Coffee</h3>
                                            <h3>Rs. 50</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={BlackTea} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Black Tea</h3>
                                            <h3>Rs. 49</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={BlackCoffee} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Black Coffee</h3>
                                            <h3>Rs. 50</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                        </div>  
                    </div> 
                    <div className='hrbg'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='menuTitle'>
                                    <h4>Cold Coffee</h4>
                                    <span>9 items</span>
                                </div> 
                            </div>
                        </div>     
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={RegularColdCoffee} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Regular Cold Coffee</h3>
                                            <h3>Rs. 89</h3>                                            
                                        </a>
                                    </div>                                        
                                </div> 
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={ColdCoffeeFrappe} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Cold Coffee Frappe</h3>
                                            <h3>Rs. 99</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={ChocolateColdCoffee} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Chocolate Cold Coffee</h3>
                                            <h3>Rs. 99</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                        </div>  
                    </div> 
                    <div className='hrbg'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='menuTitle'>
                                    <h4>Shakes</h4>
                                    <span>9 items</span>
                                </div> 
                            </div>
                        </div>     
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={CoconutPineappleShake} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Coconut Pineapple Shake</h3>
                                            <h3>Rs. 99</h3>                                            
                                        </a>
                                    </div>                                        
                                </div> 
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={BlueberryShake} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Blueberry Shake</h3>
                                            <h3>Rs. 99</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={StrawberryShake} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Strawberry Shake</h3>
                                            <h3>Rs. 99</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={ChocolateShake} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Chocolate Shake</h3>
                                            <h3>Rs. 109</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={OreoCookiesShake} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Oreo Cookies Shake</h3>
                                            <h3>Rs. 119</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={KitkatShake} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Kitkat Shake</h3>
                                            <h3>Rs. 119</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={BrownieShake} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Brownie Shake</h3>
                                            <h3>Rs. 129</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={NutellaShake} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Otlo Nutella Shake</h3>
                                            <h3>Rs. 169</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                        </div>  
                    </div>
                    <div className='hrbg'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='menuTitle'>
                                    <h4>Soft Coolers</h4>
                                    <span>9 items</span>
                                </div> 
                            </div>
                        </div>     
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={HawaiianerCooler} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Hawaiian Cooler</h3>
                                            <h3>Rs. 69</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={MazaMixito} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Maza Mixito</h3>
                                            <h3>Rs. 69</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                        </div>  
                    </div> 
                    <div className='hrbg'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='menuTitle'>
                                    <h4>Mocktail</h4>
                                    <span>9 items</span>
                                </div> 
                            </div>
                        </div>     
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={LemonMintMojito} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Lemon Mint Mojito</h3>
                                            <h3>Rs. 99</h3>                                            
                                        </a>
                                    </div>                                        
                                </div> 
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={BlueCuracaoMojito} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Blue Curacao Mojito</h3>
                                            <h3>Rs. 99</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={GreenAppleMojito} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Green Apple Mojito</h3>
                                            <h3>Rs. 99</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>                                
                            </div>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={StrawberryMojito} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Strawberry Mojito</h3>
                                            <h3>Rs. 99</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                        </div>  
                    </div>
                    <div className='hrbg'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='menuTitle'>
                                    <h4>Dessert</h4>
                                    <span>9 items</span>
                                </div> 
                            </div>
                        </div>     
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={ChoconillMix} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Choconill Mix</h3>
                                            <h3>Rs. 59</h3>                                            
                                        </a>
                                    </div>                                        
                                </div> 
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={FudgeBrownie} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Fudge Brownie</h3>
                                            <h3>Rs. 69</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>                                
                            </div>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={OtloDevil} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Otlo Devil</h3>
                                            <h3>Rs. 99</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>
                            </div>
                        </div>  
                    </div>
                    <div className='hrbg'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='menuTitle'>
                                    <h4>Shots</h4>
                                    <span>9 items</span>
                                </div> 
                            </div>
                        </div>     
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='menuDetail'>
                                    <div className='foodImg'>
                                        <img src={LemonShot} />
                                    </div>                                        
                                    <div className='menuDetail_description'>
                                        <a href="#">
                                            <h3>Lemon Shot</h3>
                                            <h3>Rs. 20</h3>                                            
                                        </a>
                                    </div>                                        
                                </div>                                 
                            </div>
                        </div>  
                    </div>
                </div>
            </div>
        </div>
      </section>
    </div>
  )
}
